module.exports = __webpack_public_path__ + "static/media/women-fas-cat-7.d54690f0.png";